webpackJsonp([189942258423953],{

/***/ 1370:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"BoardingWardFilters","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"showBoardingSchedule","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"defaultValue":null,"description":null,"name":"showPatientLocations","type":{"kind":"SCALAR","name":"Boolean","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-boarding-ward-filters-2501eab527fc816ebbf7.js